import React from 'react';
import { Button } from './Button';
import { Leaf, Activity, HeartPulse } from 'lucide-react';
export function Solution() {
  return <section className="py-24 bg-white overflow-hidden" data-id="element-148">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-149">
        <div className="grid lg:grid-cols-2 gap-16 items-center" data-id="element-150">
          {/* Image Side */}
          <div className="relative" data-id="element-151">
            <div className="absolute -inset-4 bg-sage-light/20 rounded-[3rem] transform -rotate-3" data-id="element-152"></div>
            <div className="relative rounded-[2.5rem] overflow-hidden shadow-2xl aspect-[4/3]" data-id="element-153">
              <img src="https://images.unsplash.com/photo-1548199973-03cce0bbc87b?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80" alt="Happy healthy dogs running" className="w-full h-full object-cover" data-id="element-154" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent" data-id="element-155"></div>
              <div className="absolute bottom-6 left-6 right-6 bg-white/90 backdrop-blur-sm rounded-2xl p-4 flex items-center space-x-4" data-id="element-156">
                <div className="w-12 h-12 bg-terracotta rounded-full flex items-center justify-center shrink-0" data-id="element-157">
                  <HeartPulse className="w-6 h-6 text-white" data-id="element-158" />
                </div>
                <div data-id="element-159">
                  <p className="text-sm font-bold text-gray-900" data-id="element-160">
                    Transformación en 14 días
                  </p>
                  <p className="text-xs text-gray-600" data-id="element-161">
                    Resultados visibles en energía y pelaje
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Content Side */}
          <div className="max-w-xl" data-id="element-162">
            <h2 className="text-3xl md:text-4xl font-serif font-bold text-gray-900 mb-6" data-id="element-163">
              El marco de transición de 14 días
            </h2>
            <p className="text-lg text-gray-600 mb-8" data-id="element-164">
              No necesitas ser veterinario ni pasar horas en la cocina. Nuestro
              método paso a paso te guía en una transición segura y sin estrés
              hacia una nutrición óptima.
            </p>

            <div className="space-y-6 mb-10" data-id="element-165">
              {[{
              icon: <Leaf className="w-6 h-6 text-sage-dark" data-id="element-166" />,
              title: 'Fase 1: Desintoxicación Suave (Días 1-4)',
              desc: 'Preparamos el sistema digestivo eliminando toxinas acumuladas por años de comida procesada.'
            }, {
              icon: <Activity className="w-6 h-6 text-sage-dark" data-id="element-167" />,
              title: 'Fase 2: Introducción Bio-Activa (Días 5-9)',
              desc: 'Incorporamos superalimentos y proteínas de alta biodisponibilidad sin causar malestar estomacal.'
            }, {
              icon: <HeartPulse className="w-6 h-6 text-sage-dark" data-id="element-168" />,
              title: 'Fase 3: Vitalidad Plena (Días 10-14)',
              desc: 'Consolidación de la nueva dieta. Verás cambios dramáticos en su energía, aliento y brillo del pelaje.'
            }].map((step, i) => <div key={i} className="flex" data-id="element-169">
                  <div className="mr-4 mt-1 bg-sage-light/30 w-12 h-12 rounded-full flex items-center justify-center shrink-0" data-id="element-170">
                    {step.icon}
                  </div>
                  <div data-id="element-171">
                    <h4 className="text-lg font-bold text-gray-900 mb-1" data-id="element-172">
                      {step.title}
                    </h4>
                    <p className="text-gray-600" data-id="element-173">{step.desc}</p>
                  </div>
                </div>)}
            </div>

            <Button size="lg" withArrow data-id="element-174">
              Comenzar la Transición Hoy
            </Button>
          </div>
        </div>
      </div>
    </section>;
}